import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import dropsLoader from '@/mixins/components/drops-loader';
import { cognitoMixins } from '@storm/mixins/cognito';
import { guid } from '@/mixins/guid';

export default Vue.component('edit-storm-user', {
  template: require('./template.html'),
  name: 'edit-storm-user',
  props: ['active-user'],
  mixins: [cognitoMixins, guid],
  computed: {
    ...mapGetters(['stormUser', 'stormSession']),
  },
  components: {
    dropsLoader,
  },
  data() {
    return {
      loading: false,
      confirmDisable: false,
      confirmDelete: false,
    };
  },
  methods: {
    async setEnabled() {
      this.loading = true;
      const notification = {
        id: this.guid(),
        type: 'success',
        message: 'User updated successfully!',
      };
      try {
        const status = this.activeUser.enabled ? 'disable' : 'enable';
        await this.stormInvoke({
          data: {
            method: 'stormEnableUser',
            _id: this.activeUser._id,
            status,
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.activeUser,
          key: 'enabled',
          value: !this.activeUser.enabled,
        });
        this.confirmDisable = false;
      } catch (e) {
        const message = e.message || e;
        notification.type = 'error';
        notification.message = message;
        this.$log.error(message);
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notification);
      }
    },
    async deleteUser() {
      this.loading = true;
      const notification = {
        id: this.guid(),
        type: 'success',
        message: 'User deleted successfully!',
      };
      try {
        const { _id } = this.activeUser;
        await this.stormInvoke({
          data: {
            method: 'deleteStormUser',
            _id: this.activeUser._id,
          },
        });
        this.confirmDelete = false;
        this.$emit('back');
        this.$emit('delete-user', _id);
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notification.type = 'error';
        notification.message = message;
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notification);
      }
    },
    formatDate(stamp) {
      return moment(stamp).format('MM-DD-YYYY');
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/settings-modal/storm-users/user-table/edit-user/index.js